"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiSwitchOverrides = void 0;
var styles_1 = require("@material-ui/core/styles");
var TOGGLE_WIDTH = 32;
var TOGGLE_HEIGHT = 20;
var THUMB_DIAMETER = 14;
var FOCUS_WIDTH = 3;
var BORDER_WIDTH = 1;
var createMuiSwitchOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing, transitions = _a.transitions;
    return ({
        root: {
            width: TOGGLE_WIDTH,
            height: TOGGLE_HEIGHT,
            margin: spacing(2),
            overflow: undefined,
            padding: undefined,
        },
        input: {
            left: 0,
            width: "100%",
            height: "100%",
        },
        switchBase: {
            top: spacing(-2),
            left: spacing(-2),
            padding: TOGGLE_HEIGHT - THUMB_DIAMETER / 2,
            borderRadius: "50%",
            transition: transitions.create(["left", "transform", "background-color"], {
                duration: transitions.duration.shortest,
            }),
            "&[class*='Mui-focusVisible']": {
                boxShadow: "none",
            },
            "&$checked": {
                transform: "translateX(" + (TOGGLE_WIDTH - FOCUS_WIDTH * 2 - THUMB_DIAMETER) + "px)",
            },
            "&$checked + $track": {
                opacity: undefined,
            },
            "&$disabled + $track": {
                opacity: palette.action.disabledOpacity,
            },
        },
        colorPrimary: {
            "&$switchBase": {
                background: "none",
                color: palette.common.white,
            },
            "&$checked + $track": {
                backgroundColor: palette.primary.main,
            },
            "&$checked": {
                color: undefined,
                "&:hover": {
                    backgroundColor: undefined,
                },
            },
            "&$disabled": {
                color: undefined,
            },
            "&$disabled $thumb": {
                backgroundColor: palette.type === "dark"
                    ? styles_1.alpha(palette.common.white, palette.action.disabledOpacity)
                    : palette.common.white,
            },
            "&$disabled$checked $thumb": {
                backgroundColor: palette.type === "dark"
                    ? styles_1.alpha(palette.common.white, palette.action.disabledOpacity)
                    : palette.common.white,
            },
            "& + $track": {
                backgroundColor: styles_1.alpha(palette.type === "dark"
                    ? palette.common.white
                    : palette.common.offBlack, palette.action.contrastOpacity),
            },
            "&$disabled + $track": {
                backgroundColor: undefined,
            },
        },
        thumb: {
            width: THUMB_DIAMETER,
            height: THUMB_DIAMETER,
            boxShadow: undefined,
        },
        track: {
            borderRadius: TOGGLE_HEIGHT / 2,
            opacity: undefined,
            "$root:hover $checked$disabled + &": {
                backgroundColor: palette.primary.main,
            },
            "&::before": {
                position: "absolute",
                top: -BORDER_WIDTH,
                right: -BORDER_WIDTH,
                bottom: -BORDER_WIDTH,
                left: -BORDER_WIDTH,
                backgroundColor: palette.action.hover,
                borderRadius: TOGGLE_HEIGHT + (BORDER_WIDTH * 2) / 2,
                content: "''",
                opacity: 0,
                pointerEvents: "none",
                transition: transitions.create(["opacity", "box-shadow"], {
                    duration: transitions.duration.shortest,
                }),
                "$switchBase[class*='Mui-focusVisible'] + &": {
                    boxShadow: "0 0 0 " + BORDER_WIDTH + "px " + palette.text.primary,
                },
                "$switchBase[class*='Mui-focusVisible']:not($disabled) + &, $root:hover :not($disabled) &": {
                    opacity: 1,
                },
            },
        },
        // TODO: Update when VDL has designs for "small". Without this, setting it to small will use default styles
        sizeSmall: {
            width: undefined,
            height: undefined,
            padding: undefined,
            "& $thumb": {
                width: undefined,
                height: undefined,
            },
            "& $switchBase": {
                padding: undefined,
                "&$checked": {
                    transform: undefined,
                },
            },
        },
    });
};
exports.createMuiSwitchOverrides = createMuiSwitchOverrides;
//# sourceMappingURL=MuiSwitch.js.map